import {
  HeaderController,
  BIRDModelController,
  HeaderLocation as BirdHeaderLocation,
} from '@sas-dvr/ltjs-bird';
import { merge, Observable, of, from, EMPTY } from 'rxjs';
import { BirdLayoutState } from '@sas-dvr/internal-va-react-core/store/birdLayout/BirdLayoutState';
import { filterNulls, getKey } from '../util';
import { AnyAction } from 'redux';
import { mergeMap } from 'rxjs/operators';
import { EpicActions } from '../actions/epicActions';
import {
  HeaderLocation,
  PromptHeaderState,
} from '@sas-dvr/internal-va-react-core/store/promptHeader/promptHeaderState';
import { StateObservable } from 'redux-observable';
import { ReportState } from '@sas-dvr/internal-va-react-core/store/rootReducer';
import { selectPromptHeaderState } from '@sas-dvr/internal-va-react-core/store/selectors';

export const loadHeaderController = (
  controller: HeaderController | null,
  unload$: Observable<BIRDModelController>,
  id: string,
  state$: StateObservable<ReportState>
): Observable<AnyAction> => {
  if (!controller) {
    return of(PromptHeaderState.actions.init(id, { location: 'top', status: 'auto' }));
  }
  const mediaContainerController = controller.getMediaContainerController();
  if (!mediaContainerController) {
    return of(PromptHeaderState.actions.init(id, { location: 'top', status: 'auto' }));
  }
  const childControllers = filterNulls(
    mediaContainerController.getOrderedVisualAndContainerControllers()
  );

  const location = convertHeaderLocation(controller.getLocation());
  return merge(
    selectPromptHeaderState(state$.value, id)
      ? EMPTY
      : of(
          PromptHeaderState.actions.init(id, {
            status: 'auto',
            location,
            width: controller.getModel()?.getPropertyHandle('width')?.hasOverride()
              ? controller.getModel()?.getWidth() || undefined
              : undefined,
          })
        ),
    from(childControllers.map(EpicActions.actions.loadBirdModel)),
    unload$.pipe(mergeMap(() => from(childControllers.map(EpicActions.actions.unloadBirdModel)))),
    of(BirdLayoutState.actions.set(id, { childKeys: childControllers.map(getKey) }))
  );
};

function convertHeaderLocation(headerLocation: BirdHeaderLocation): HeaderLocation {
  switch (headerLocation) {
    case BirdHeaderLocation.LEFT:
      return 'left';
    case BirdHeaderLocation.RIGHT:
      return 'right';
    case BirdHeaderLocation.BOTTOM:
      return 'bottom';
    case BirdHeaderLocation.TOP:
    default:
      return 'top';
  }
}
